import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { object } from 'prop-types'
import { withRouter } from 'react-router-dom'
import { useParams } from '../../utilities/url'
import { stores } from '../../stores'
import { PagesPaths } from '../../constants/Pages'

/**
 * Special component - called from the administration
 * to connect to a customer account.
 * Params are passed as parameters - redirect to account if authentication is successful
 */
class ConnectAsComponent extends Component {
  async componentDidMount () {
    const { location, history } = this.props
    const params = useParams(location.search)
    await stores.connectAs(params)
    if (stores.authentication.isAuthententicated()) {
      history.replace(PagesPaths.ACCOUNT.path)
    } else {
      history.replace(PagesPaths.SIGNIN.path)
    }
  }

  render () {
    return (<span />)
  }
}

ConnectAsComponent.propTypes = {
  location: object,
  history: object
}

export const ConnectAs = withRouter(translate()(ConnectAsComponent))



// WEBPACK FOOTER //
// ./src/pages/authentification/ConnectAs.js